import { ReturnAssessmentGroupsSchema } from "@redotech/redo-return-core-common/return-assessments/assessment-schemas";

export const updateGroup = {
  name: "updateGroup" as const,

  input: ReturnAssessmentGroupsSchema,

  output: ReturnAssessmentGroupsSchema,
};
